module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0146.jpg?v=5cdc36f6";